import Vue from 'vue'
import 'reset-css'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './assets/icons/index'

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
